import React, { useEffect, useState } from 'react';
import codes from '../../../utils/constants/codes';
// @ts-ignore
import internalErrors from './internalErrorsPage.module.scss';
// @ts-ignore
import warning from '../../../assets/images/warning.png';
import CopyPasteIcon from '../../icons/copyPasteIcon';
import CheckedIcon from '../../icons/checkedIcon';
import PhoneNoFillIcon from '../../icons/phoneNoFillIcon';
import EmailIcon from '../../icons/emailIcon';
import { store } from '../../../store/store';
import aragLogo from '../../../assets/images/araglogo3@2x.png';

function InternalErrorsPage() {
    const [copied, setCopied] = useState(false);

    useEffect(() => {
        setTimeout(() => setCopied(false), 3000);
    }, [copied]);

    const copy = item => {
        const el = document.createElement('input');
        el.value = item;
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
        setCopied(true);
    };
    const currentCountryCode = store
        .getState()
        .applicationSettings.apiApplicationSettings?.currentCountryCode.toUpperCase();

    return (
        <div
            className={`${internalErrors['content']}`}
            style={{
                backgroundImage: `url(${warning})`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'contain',
            }}
        >
            <div className={`${internalErrors['logoText']}`}>
                <img
                    className={`${internalErrors['logo']}`}
                    src={aragLogo}
                    alt="ARAG Logo"
                />
                <div className={internalErrors['text']}>
                    <p>{codes.blankPage}</p>
                </div>
                <div className={internalErrors['secondary-text']}>
                    <p>{codes.contactIT}</p>
                </div>
                <div className={'row'}>
                    <div className={`${internalErrors['email']} col-sm-1 `}>
                        <PhoneNoFillIcon
                            className={internalErrors['mainIcon']}
                        />
                    </div>
                    <div className={`${internalErrors['phone']} col-sm-10`}>
                        <p className={internalErrors['emailText']}>
                            {codes[`emailContactNumber${currentCountryCode}`] ||
                                'Unknown'}
                        </p>
                    </div>
                </div>
                <div className={'row'}>
                    <div className={`${internalErrors['email']} col-sm-1 `}>
                        <EmailIcon className={internalErrors['mainIcon']} />
                    </div>
                    <div className={`${internalErrors['link']} col-sm-10`}>
                        <div className={internalErrors['tooltip']}>
                            <button
                                onClick={() =>
                                    copy(
                                        codes[
                                            `emailContactEmail${currentCountryCode}`
                                        ] || 'Unknown',
                                    )
                                }
                                className={internalErrors['btn']}
                                id={'internal-button'}
                            >
                                <span
                                    className={internalErrors['tooltipText']}
                                    id={'tooltipText'}
                                >
                                    {codes.copyToClipboard}
                                </span>
                                {codes[
                                    `emailContactEmail${currentCountryCode}`
                                ] || 'Unknown'}
                                {!copied ? (
                                    <CopyPasteIcon
                                        className={internalErrors['icon']}
                                        id={'copyPaste'}
                                    />
                                ) : (
                                    <CheckedIcon
                                        className={internalErrors['icon']}
                                        id={'checked'}
                                    />
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default InternalErrorsPage;
